var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,2.9c-6.6,0-12,5.4-12,12s5.4,12,12,12c0.7,0,1.3-0.1,2-0.2v4.2h14v-14H16v1v6.8c-0.6,0.1-1.3,0.2-2,0.2 c-5.5,0-10-4.5-10-10s4.5-10,10-10c3.3,0,6.2,1.6,8,4h-4v2h7v-7h-2V7C20.8,4.5,17.6,2.9,14,2.9z M18,18.9h10v10H18V18.9z M26,20.8 l-3.3,3.3l-2.3-2.3L19,23.2l3.7,3.7l4.7-4.7L26,20.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeStatus);
export default __webpack_public_path__ + "static/media/change-status.da8bae575c0f873ddcbb9bf8d6afb260.svg";
export { ForwardRef as ReactComponent };